import { api, apiBase } from './client';
import type { ClientRow, ClientDetail, Env } from '../types';

export function fetchClients(params: URLSearchParams) {
  return api<ClientRow[]>(`/clients?${params.toString()}`);
}

export function fetchClient(uuid: string, env: Env) {
  return api<ClientDetail>(`/clients/${encodeURIComponent(uuid)}?env=${env}`);
}

/** Synthetic "Stock ZCE" client: ownerless devices. */
export function fetchStock(env: Env) {
  return api<ClientDetail>(`/clients/stock?env=${env}`);
}

export function clientsExportUrl(env: Env): string {
  return `${apiBase()}/export/clients.csv?env=${env}`;
}
